import { render, staticRenderFns } from "./initial-left-column.vue?vue&type=template&id=6e51d7fc&scoped=true&"
import script from "./initial-left-column.vue?vue&type=script&lang=ts&"
export * from "./initial-left-column.vue?vue&type=script&lang=ts&"
import style0 from "./initial-left-column.vue?vue&type=style&index=0&id=6e51d7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51d7fc",
  null
  
)

export default component.exports